export default {
    carbonCredit: {
        view: 'Ver',
        edit: 'Editar',
        back: 'Atrás',
        preview: 'Vista previa',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        dashboard: 'Panel de control',
        select: 'Seleccionar',
        submit: 'Enviar',
        save: 'Guardar',
        title: 'Crédito de Carbono',
        projects: 'Proyectos',
        carbonProjectCredits: 'Créditos de Proyecto de Carbono',
        carbonCreditProjects: 'Proyectos de Crédito de Carbono',
        exportAs: 'Exportar como',
        downloadAsCSV: 'Descargar como CSV',
        downloadAsExcel: 'Descargar como Excel',
        downloadAsPDF: 'Descargar como PDF',
        registerNewProject: 'Registrar Nuevo Proyecto',
        creditInfo: '*Este es el número aproximado de créditos. El número real de créditos puede ser diferente después de la verificación.',
        search: 'Buscar',
        projectTitle: 'Título del Proyecto',
        projectType: 'Tipo de Proyecto',
        country: 'País',
        totalCreditsGenerated: 'Total de Créditos Generados',
        status: 'Estado',
        descriptionPlaceholder: "Por favor proporcione una descripción del proyecto incluyendo objetivos",
        filePreviewNotAvailable: 'La vista previa del archivo no está disponible para este tipo de archivo',
        active: 'Activo',
        inactive: 'Inactivo',
        pending: 'Pendiente',
        proposed: 'Propuesto',
        planned: 'Planificado',
        inProgress: 'En Progreso',
        operational: 'Operacional',
        deactivated: 'Desactivado',
        avoidedDeforestation: 'Deforestación Evitada',
        agroForestry: 'Agroforestería',
        forestry: 'Silvicultura',
        regenerativeAgriculture: 'Agricultura Regenerativa',
        agroforestry: 'Agroforestería',
        regenerative_agriculture: 'Agricultura Regenerativa',
        projectDeletedSuccessfully: 'Proyecto desactivado exitosamente',
        projectUpdatedSuccessfully: 'Proyecto actualizado exitosamente',
        projectRegisteredSuccessfully: 'Proyecto registrado exitosamente',
        deactivateProjectError: 'Error al desactivar el proyecto',
        deactivate: 'Desactivar',
        deactivateProject: 'Desactivar Proyecto',
        deactivateConfirmation: '¿Está seguro de que desea desactivar este proyecto?',
        registerProject: 'Registrar un Nuevo Proyecto',
        editProject: 'Editar Proyecto',

        register: { 
            title: 'Registrar un Proyecto',
            editTitle: 'Editar Proyecto',
            projectTitle: 'Título del Proyecto',
            projectType: 'Tipo de Proyecto',
            description: 'Descripción',
            selectCountry: "Seleccionar País",
            selectOrganization: 'Seleccionar Organizaciones',
            status: 'Estado',
            creditType: 'Tipo de Crédito',
            creditStart: 'Inicio de Crédito',
            creditEnd: 'Fin de Crédito',
            standardMethodology: 'Estándar/Metodología',
            validationDocumentation: 'Documentación de Validación',
            vintage: 'Añada',
            currency: 'Moneda',
            projectInfo: 'Información del Proyecto',
            organizationDetails: 'Detalles de Organizaciones',
            attachmentTitle: 'Adjunto(s)',
            attachmentInfo: 'Puede agregar cualquier documento adicional, imágenes, video y archivos de audio relevantes para el proyecto',
            documentation: 'Documentación',
            sdgsTitle: 'Objetivos de Desarrollo Sostenible (ODS)',
            sdgsInfo: 'Por favor seleccione solo los objetivos relevantes para este proyecto específico. Las organizaciones tendrán acceso para ver solo los objetivos vinculados a este proyecto.',
            dataCollectionTitle: 'Ciclo de Recolección de Datos',
            dataCollectionInfo: 'Para participar en el Programa de Crédito de Carbono, los agricultores deben proporcionar datos históricos de la granja durante la inscripción y continuar enviando actualizaciones de datos periódicas mientras el programa permanezca activo. Esto asegura un seguimiento preciso del rendimiento del carbono a lo largo del tiempo.',
            vintageYear: 'Año de Añada',
            estimatedCredit: 'Créditos Estimados',
            pricePerCredit: 'Precio Por Crédito',
            moduleName: 'Nombre del Módulo',
            futureData: 'Recolección de Datos Recurrentes Futuros',
            score: 'Puntuación',
            approval: 'Aprobación',

            projectAgreement: 'Acuerdo del Proyecto',
            headerImage: 'Imagen de Encabezado',
            headerImageInfo: '(Tamaño de imagen de encabezado 1920 x 420 píxeles. La imagen predeterminada será reemplazada con la nueva imagen que suba)',
            headerImagePlaceholder: "Imagen de Encabezado Predeterminada",
            responsibleDimitraOffice: 'Oficina de Dimitra Responsable',
            selectDimitraOffice: 'Seleccionar Oficina de Dimitra',
            makeASelection: 'Hacer una Selección',
            addNewDimitraOffice: 'Agregar Nueva Oficina de Dimitra',
            editDimitraOffice: 'Editar Oficina de Dimitra',
            officeName: 'Nombre de la Oficina',
            contactPerson: 'Nombre de la Persona de Contacto',
            phoneNumber: 'Número de Teléfono',
            email: 'Correo Electrónico',
            address: 'Dirección',
            officeNameRequired: 'El nombre de la oficina es requerido',
            contactPersonRequired: 'El nombre de la persona de contacto es requerido',
            addressRequired: 'La dirección es requerida',
            phoneNumberRequired: 'El número de teléfono es requerido',
            phoneNumberInvalid: 'El número de teléfono no es válido',
            phoneNumberLength: 'El número de teléfono debe tener al menos 10 dígitos',
            selectVintage: 'Seleccionar Añada',
            officeAddedSuccessfully: 'Oficina de Dimitra agregada exitosamente',
            errorAddingOffice: 'Error al agregar oficina de Dimitra',
            searchOrganizations: 'Buscar Organizaciones',
            searchOrganizationsPlaceholder: 'Buscar por nombre de organización...',
            noOrganizationsFound: 'No se encontraron organizaciones',
            loadingOrganizations: 'Cargando organizaciones...',
            selectedOrganizations: 'Organizaciones Seleccionadas',
            errorNegative: 'no puede ser negativo.',
            errorRequiredField: '{field} es requerido.',
            errorOrganizationRequired: 'Al menos una organización debe ser seleccionada.',
            errorVintageRequired: 'Al menos una entrada de añada es requerida.',
            errorVintageFieldsRequired: 'Todos los campos de añada (año, créditos, precio) son requeridos.',
            allOrganizations: 'Todas las Organizaciones',
            removal: 'Remoción',
            avoided: 'Evitado',
            mandatory: 'Obligatorio',
            scoreValidationError: 'Puntuación inválida para el módulo "{module}". La puntuación debe ser un número entero 0 o mayor.',
            approvalValidationError: 'Aprobación inválida para el módulo "{module}". La aprobación debe ser un número entero entre 0 y 100.',
            saveError: 'Error al guardar el proyecto',
            fileUploadFailed: 'Error al Subir Archivo',
            unsupportedFileFormat: 'Formato de archivo no soportado',
            errorUploadingFile: 'Error al subir archivo',
            scoreError: {
                invalid: 'La puntuación debe ser un número válido',
                range: 'La puntuación debe ser 0 o mayor',
                wholeNumber: 'La puntuación debe ser un número entero'
            },
            approvalError: {
                invalid: 'La aprobación debe ser un número válido',
                range: 'La aprobación debe estar entre 0 y 100',
                wholeNumber: 'La aprobación debe ser un número entero'
            },
            selectStatus: 'Seleccionar Estado',
            selectCreditType: 'Seleccionar Tipo de Crédito',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Estándar',
            browse: 'Navegar',
            currencyPlaceholder: 'USD',
            selectFile: 'Seleccionar Archivo',
            dragDropFiles: 'Arrastrar y soltar archivos aquí',
            hideDetails: 'Ocultar Detalles',
            viewDetails: 'Ver Detalles',
            website: 'Sitio Web',
            month: 'Mes(es)',
            year: 'Año(s)',
        },

        error: 'Error',
        success: 'Éxito',
        remove: 'Eliminar',

        projectInfo: {
            title: 'Información del Proyecto',
            organizationDetail: 'Detalle de Organización',
            subOrganizations: 'Sub-Organizaciones',
            search: 'Buscar',
            organizations: 'Organizaciones',
            users: 'Usuarios',
            registrationDate: 'Fecha de Registro',
            close: 'Cerrar',
            country: 'País',
            organizationsAddress: 'Dirección de Organizaciones',
            blockchainAddress: 'Dirección de Blockchain',
            creditType: 'Tipo de Crédito',
            projectType: 'Tipo de Proyecto',
            officeName: 'Nombre de la Oficina',
            contactPersonName: 'Nombre de la Persona de Contacto',
            contactNumber: 'Número de Contacto',
            email: 'Correo Electrónico',
            address: 'Dirección',
            website: 'Sitio Web',
            companyName: 'Nombre de la Empresa',
            companyAddress: 'Dirección de la Empresa',
            web: 'Sitio Web',
            vintageYear: 'Año de Añada',
            estimatedCredits: 'Créditos Estimados',
            pricePerCredit: 'Precio Por Crédito',
            module: 'Módulo',
            recurring: 'Recurrente',
            score: 'Puntuación',
            approval: 'Aprobación',
            responsibleDimitraOffice: 'Oficina de Dimitra Responsable',
            status: 'Estado',
            standardMethodology: 'Estándar/Metodología',
            validationDocumentation: 'Documentación de Validación',
            creditStart: 'Inicio de Crédito',
            creditEnd: 'Fin de Crédito',
            attachmentTitle: 'Adjunto(s)',
            sdgsTitle: 'Objetivos de Desarrollo Sostenible (ODS)',
            dataCollectionTitle: 'Ciclo de Recolección de Datos',
            dataCollectionInfo: 'Para participar en el Programa de Crédito de Carbono, los agricultores deben proporcionar datos históricos de la granja durante la inscripción y continuar enviando actualizaciones de datos periódicas mientras el programa permanezca activo. Esto asegura un seguimiento preciso del rendimiento del carbono a lo largo del tiempo.',
            vintage: 'Añada',
            moduleName: 'Nombre del Módulo',
            futureData: 'Recolección de Datos Recurrentes Futuros',
            estimatedCredit: 'Créditos Estimados',
        },

        user: {
            title: 'Usuario(s) de Crédito de Carbono',
            selectOrganization: 'Seleccionar Organización',
            selectProject: 'Seleccionar Proyecto',
            allUsers: 'Todos los Usuarios',
            activeUsers: 'Usuarios Activos',
            deactivatedUsers: 'Usuarios Desactivados',
            pendingUsers: 'Usuarios Pendientes',
            search: 'Buscar',
            farmerName: 'Nombre del Agricultor',
            farmName: 'Nombre de la Granja',
            organizations: 'Organizaciones',
            country: 'País',
            projectTitle: 'Título del Proyecto',
            registerProject: 'Registrar un Nuevo Proyecto',
            actions: 'Acciones',
            noData: 'No se encontraron usuarios.',
            view: 'Ver',
            viewLandPermit: 'Ver Título de Tierra / Permiso',
            edit: 'Editar',
            deactivate: 'Desactivar',
            deactivateUser: 'Desactivar Usuario',
            deactivateConfirmation: '¿Está seguro de que desea desactivar este usuario?',
            activate: 'Activar',
            activateUser: 'Activar Usuario',
            activateConfirmation: '¿Está seguro de que desea activar este usuario?',
            deactivatedSuccessfully: 'Usuario desactivado exitosamente',
            activatedSuccessfully: 'Usuario activado exitosamente',
            deactivationFailed: 'Error al desactivar usuario',
            exportAsPdf: 'Exportar como PDF',
            projectDetails: 'Detalles del Proyecto',
            dateJoined: 'Fecha de Ingreso',
            cropGrowingPractice: 'Práctica de Cultivo',
            farm: 'Granja',
            rejectAll: 'RECHAZAR TODO',
            acceptAll: 'ACEPTAR TODO',
            confirmRejectAll: 'Está a punto de rechazar solicitudes para que todas las granjas se unan al proyecto de crédito de carbono. Esta acción excluirá todas las granjas enviadas por el agricultor en esta solicitud. ¿Está seguro de que desea continuar?',
            confirmAcceptAll: 'Está a punto de aceptar solicitudes para que todas las granjas se unan al proyecto de crédito de carbono. Esta acción incluirá todas las granjas enviadas por el agricultor en esta solicitud. ¿Está seguro de que desea continuar?',
            dateOfRegistration: 'Fecha de Registro',
            farmRegistrationId: 'ID de Registro de Granja',
            dimitraFarmId: 'ID de Granja Dimitra',
            notTheFarmer: "No soy el Agricultor",
            farmerFirstName: 'Primer Nombre del Agricultor',
            farmerMiddleName: 'Segundo Nombre del Agricultor',
            farmerLastName: 'Apellido del Agricultor',
            farmerRegistrationId: 'ID de Registro del Agricultor',
            dimitraFarmerId: 'ID de Agricultor Dimitra',
            farmGeofence: 'Geocerca de Granja',
            viewGeofence: 'Ver Geocerca',
            totalFarmSize: 'Tamaño Total de Granja',
            mainGoals: '¿Cuáles son Sus Objetivos Principales',
            ownershipType: 'Tipo de Propiedad',
            certifications: 'Certificación(es)',
            productionType: 'Tipo de Producción',
            landTitle: 'Título de Tierra',
            farmLocationAddress: 'Dirección de Ubicación de Granja',
            farmCoordinate: 'Coordenada de Granja',
            farmerAgreement: 'Acuerdo del Agricultor',
            viewSignedAgreement: 'Ver acuerdo firmado enviado con la solicitud.',
            viewAgreement: 'VER ACUERDO',
            acceptanceStatus: 'Estado de Aceptación',
            currentStatus: 'Estado Actual',
            reject: 'RECHAZAR',
            accept: 'ACEPTAR',
            farmActivitySubmissions: 'Envíos de Actividad de Granja',
            farmActivitySubmissionsDesc: 'Registros enviados de prácticas agrícolas y actualizaciones requeridas para la verificación de crédito de carbono.',
            viewFarmData: 'VER DATOS DE GRANJA',
            farmData: 'Datos de Granja',
            farmDataDesc: 'Cree sus reportes integrando datos de producción de varias fuentes. Seleccione una o múltiples fuentes para compilar una lista completa de lugares de producción para sus reportes.',
            crops: 'Cultivos',
            sowing: 'Siembra',
            seedling: 'Plántula',
            fertilizer: 'Fertilizante',
            fertilizerError: 'Envío incompleto: La información de fertilizante para 4 meses falta en la entrada del agricultor.',
            harvesting: 'Cosecha',
            livestock: 'Ganado',
            equipment: 'Equipamiento',
            projectRequests: 'Solicitudes de Proyecto',
            userNameAndId: 'Nombre de Usuario y ID',
            email: 'Correo Electrónico',
            userRole: 'Rol de Usuario',
            status: 'Estado',
            userRegistrationDate: 'Fecha de Registro de Usuario',
            pending: 'Pendiente',
            deactivated: 'Desactivado',
            active: 'Activo',
            selectProjectTypeFirst: 'Seleccione el Tipo de Proyecto Primero',
            noFarmsToReject: 'No hay granjas para rechazar',
            allFarmsRejected: 'Todas las granjas rechazadas correctamente',
            rejectAllError: 'Error al rechazar todas las granjas',
            noFarmsToAccept: 'No hay granjas para aceptar',
            allFarmsAccepted: 'Todas las granjas aceptadas correctamente',
            acceptAllError: 'Error al aceptar todas las granjas',
            farmNotFound: 'Granja no encontrada o no asociada al proyecto',
            farmAlreadyRejected: 'La granja ya está rechazada',
            farmRejected: 'Granja rechazada correctamente',
            rejectFarmError: 'Error al rechazar la granja',
            farmAlreadyAccepted: 'La granja ya está aceptada',
            farmAccepted: 'Granja aceptada correctamente',
            acceptFarmError: 'Error al aceptar la granja',
        },
    }
} 